module.exports = __webpack_public_path__ + "img/18_76.d1e105a2.png";